export default __webpack_public_path__ + "static/media/traveler-inside-train-2x.23e91cdc.webp";